'use client';

import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

export default function AcceptanceSection() {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary to-primary/80 rounded-2xl shadow-premium p-8 lg:p-12 text-white">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="DocumentCheckIcon" size={24} className="text-white" />
              </div>
              <div>
                <h2 className="text-2xl lg:text-3xl font-display font-bold mb-3">
                  Terms Acceptance
                </h2>
                <p className="text-white/90 text-lg">
                  By making a reservation or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
                </p>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6">
              <h3 className="text-lg font-semibold mb-4">Explicit Acceptance Mechanisms</h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <Icon name="CheckCircleIcon" size={20} className="text-accent flex-shrink-0 mt-0.5" />
                  <span className="text-white/90">Checkbox confirmation during online booking process</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Icon name="CheckCircleIcon" size={20} className="text-accent flex-shrink-0 mt-0.5" />
                  <span className="text-white/90">Signature on booking confirmation documents</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Icon name="CheckCircleIcon" size={20} className="text-accent flex-shrink-0 mt-0.5" />
                  <span className="text-white/90">Digital acceptance via email confirmation</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Icon name="CheckCircleIcon" size={20} className="text-accent flex-shrink-0 mt-0.5" />
                  <span className="text-white/90">Verbal confirmation recorded during phone bookings</span>
                </li>
              </ul>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6">
              <h3 className="text-lg font-semibold mb-3">Terms Updates</h3>
              <p className="text-white/90 mb-3">
                Proximus reserves the right to modify these terms at any time. Changes will be effective immediately upon posting on our website. Continued use of our services after changes constitutes acceptance of modified terms.
              </p>
              <p className="text-white/90">
                <strong>Last Updated:</strong> January 7, 2026
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://bookingengine.stayflexi.com/?hotel_id=33526"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-elevated transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2"
              >
                <Icon name="CalendarIcon" size={20} className="text-white" />
                <span>Book Now</span>
              </a>
              <Link
                href="/privacy-policy"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <Icon name="ShieldCheckIcon" size={20} className="text-white" />
                <span>Privacy Policy</span>
              </Link>
              <Link
                href="/contact-us"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-white" />
                <span>Contact Us</span>
              </Link>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-text-secondary text-sm">
              For questions about these terms, please contact our legal department at{' '}
              <a href="mailto:legal@proximusapartments.com" className="text-primary hover:underline">
                legal@proximusapartments.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}